import FieldsPayStubLastStep from './FieldsPayStubLastStep'

export default FieldsPayStubLastStep
